import React, { useState } from 'react';
import * as S from './style';

import { ReactComponent as CheckOn } from 'assets/img/common/btn_checkbox_on.svg';
import { ReactComponent as CheckOff } from 'assets/img/common/btn_checkbox_off.svg';

export interface Props {
    title: string;
    description?: string;
    value: string;
    checked?: boolean;
    disabled?: boolean;
    onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>, isChecked?: boolean, value?: string) => void;
}

function CheckBoxDesc({ title, description, value, checked = false, disabled, onClick }: Props): React.ReactElement {
    const [isChecked, setIsChecked] = useState<boolean>(checked);
    return (
        <S.CheckBoxDesc
            checked={isChecked}
            onClick={(event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
                if (!disabled) {
                    onClick && onClick(event, !isChecked, value);
                    setIsChecked(!isChecked);
                }
            }}
        >
            <S.CheckBoxDescDimd />
            <S.IconWrapper>{isChecked ? <CheckOn /> : <CheckOff />}</S.IconWrapper>
            <S.LabelWrapper>
                <S.LabelTitle fontStyle={'body2'} contents={title} />
                {description ? <S.LabelDescription fontStyle={'caption'} contents={description} /> : null}
            </S.LabelWrapper>
        </S.CheckBoxDesc>
    );
}

export default CheckBoxDesc;
